/**
 * @generated SignedSource<<b5a18eb1c8047c4ccd52097a8f766e7d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedShippingInfoWrapper_item$data = {
  readonly serviceId: string | null;
  readonly " $fragmentType": "PdpSharedShippingInfoWrapper_item";
};
export type PdpSharedShippingInfoWrapper_item$key = {
  readonly " $data"?: PdpSharedShippingInfoWrapper_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedShippingInfoWrapper_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedShippingInfoWrapper_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "7845572d00cb53cb297c1d90b6022a81";

export default node;
